export default __webpack_public_path__ + "static/media/banners_banana_chimp.a6119558.png";